import lodash from 'lodash';

import { generateElementId } from 'bundles/author-common/utils/IdUtils';
import { TOPK } from 'bundles/authoring/grading-formula/constants/GradedAssignmentGroupGradingTypes';
import type { GradingType, PassingPolicy } from 'bundles/authoring/grading-formula/types/GradedAssignmentGroup';

import type ItemGradeWeight from './GradeWeight/ItemGradeWeight';

export type GradedAssignmentGroupWithWeights = GradedAssignmentGroup & { elements: Array<ItemGradeWeight> };

export type GradedAssignmentGroupChange = {
  name: string;
  itemIds: Array<string>;
  passingPolicies?: Array<PassingPolicy> | undefined | null;
  gradingWeight: number;
  gradingType: GradingType;
  id: string;
};

/**
 * Model for Graded Assignment Groups
 */
export class GradedAssignmentGroup {
  declare name: string;

  declare itemIds: Array<string>;

  declare passingPolicies?: Array<PassingPolicy> | undefined | null;

  declare gradingWeight: number;

  declare gradingType: GradingType;

  declare id: string;

  declare numberOfSelectedItems: number | null;

  declare elements?: Array<ItemGradeWeight>;

  constructor({ name, itemIds, passingPolicies, gradingWeight, gradingType, id }: GradedAssignmentGroupChange) {
    this.name = name;
    this.id = id || generateElementId();
    this.itemIds = itemIds;
    this.gradingWeight = gradingWeight;
    this.gradingType = gradingType;
    this.passingPolicies = passingPolicies;
    this.numberOfSelectedItems =
      gradingType && gradingType.typeName === TOPK
        ? gradingType.definition && gradingType.definition.numberOfSelectedItems
        : null;
  }

  clone() {
    const clonedFields = lodash.cloneDeep(this);
    return new GradedAssignmentGroup({ ...clonedFields });
  }
}

export default GradedAssignmentGroup;
